import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Fire from 'app/components/SVGS/Fire'
import classNames from 'classnames'

class UserBoardActivityStatsStreakDetails extends Component {
  render() {
    let { t, streakCurrent } = this.props
    const noStreak = !streakCurrent
    return (
      <div className="prohabit__part prohabit__part-home prohabit__part--right prohabit__part--right-home">
        <div className="streak streak-home">
          <div
            className={classNames('fire', {
              'fire--no-streak': noStreak,
              'fire--animation': !noStreak,
            })}
          >
            <Fire noStreak={noStreak} />
          </div>
          <div className="stats">
            <div className="stats__days">
              <span className={classNames({ stats__current: true, 'stats__current--no-streak': noStreak })}>
                {streakCurrent}
              </span>
            </div>
            <div className="stats__title stats__title-home">
              {t('Streak')}
              <br />&nbsp;
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation('user')(UserBoardActivityStatsStreakDetails)
